export const NAME = 'user';



// WEBPACK FOOTER //
// ./src/user/constants.js